import React, { FC } from 'react';
import styles from './styles.module.css';
import { useDocumentsContext } from 'Policies/utils/DocumentsContext';
import { Asset, WarningIcon } from '@clearcover/atlas';

export const UnsignedPacketsAlert: FC<{}> = () => {
  const { documents, loading, error } = useDocumentsContext();

  if (error || loading) return null;

  const unsignedDocs = documents.filter(
    doc =>
      doc.type === 'signable_doc' && !doc.completedAt && doc.signatureWorkflow
  );

  return (
    <>
      {unsignedDocs.map(doc => (
        <div
          key={doc.id}
          data-testid="unsigned-packets-alert"
          className={styles.unsignedPacketsAlert}
        >
          <div className={styles.iconContainer}>
            <Asset
              icon={WarningIcon}
              height={16}
              width={16}
              description="Warning icon"
            />
          </div>
          <div className={styles.textContainer}>
            <span data-testid="unsigned-packets-alert-text">
              Policy owner has not submitted the
              {convertWorkflowToText(doc.signatureWorkflow)}
              signature packet for this policy.
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

function convertWorkflowToText(signatureWorkflow?: string) {
  switch (signatureWorkflow) {
    case 'NEW_BUSINESS':
    case 'NEW_BUSINESS_AGENT':
      return ' new business ';
    case 'GAP4_REMEDIATION':
    case 'RENEWAL_OFFER':
      return ' renewal ';
    default:
      return ' ';
  }
}
